// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft Enterprise API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum OrderDetailStatus {
    Backordered = 'Backordered',
    Complete = 'Complete',
    Incomplete = 'Incomplete',
    Skipped = 'Skipped',
    Unknown = 'Unknown',
    UnknownDefaultOpenApi = '11184809'
}



